


































































































































































































import { Component, Vue } from "vue-property-decorator";
import api from "@/api";
import store from "@/store";
@Component({})
export default class realtimeOrder extends Vue {
  detail = {};
  detailDialog = false;
  // 表格数据
  tableData = [];
  // 加载状态
  loading = false;
  // 总条数
  total = 0;
  // 搜索条件
  search: any = {
    id: "",
    channelId: "",
    tradingCenterCode: "",
    created_at: [],
    pagination: {
      page: 0, //页码，从0开始
      pageSize: 20, //每页数量
    },
  };

  logDialog = false;
  logList = [];
  logTotal = 0;
  listLoading = false;
  log = {
    bus_id: "",
    module_code: "goodsOrdManager",
    // goodsOrdManager: '',
    pagination: {
      page: 0, //页码，从0开始
      pageSize: 20, //每页数量
    },
  };
  lookLogDialog = false;

  // 日志
  openDesc = false
  row = {}
  cancleLog() {
    this.logDialog = false;
  }

  // logTotal = 0
  logSearch = {
    objectId: "",
    objectType: "payment_manage",
    pagination: {
      page: 0, //页码，从0开始
      pageSize: 10, //每页数量
    },
  };
  logTable = [];
  toLog(item: any) {
    // this.log.dataIndex = this.order.id;
    // this.log.pagination.page = 1;
    this.logSearch.objectId = item.id;
    api.post("J27764", { ...this.logSearch }).then((res) => {
      this.logDialog = true;
      this.logTable = res.list;
      this.logTotal = res.total;
    });
  }

  changeLog(page: any) {
    this.log.pagination.page = page - 1;
    api.post("J27721", { ...this.logSearch }).then((res) => {
      // this.logDialog = true
      this.logTable = res.list;
      this.logTotal = res.total;
    });
  }


  handleCloseDetail() {
    this.detailDialog = false;
  }

  logDetail = false
  toLogDetail(row: any) {
    this.logDetail = true;
    this.row = row;
  }

  CloseLogDetailDialog() {
    this.logDetail = false;
  }

  // 搜索 search:true 重置翻页
  searchTable(search = false) {
    this.loading = true;
    if (search) {
      this.search.pagination = {
        pageSize: 20,
        page: 0,
      };
    }
    api
      .post("J27736", {
        ...this.search,
      })
      .then((data) => {
        this.total = data.total;
        this.tableData = data.list;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  toDetail(row: any) {
    api.post("J27735", { id: row.id }).then((res) => {
      this.detail = res;
      this.detailDialog = true;
    });
  }

  toOrder(row: any) {
    this.$router.push({
      path: "/shop/listDetail",
      query: {
        id: row.orderId,
      },
    });
  }

  config = {}
  getConfig() {
    api.getJavaConfig().then((res) => {
      this.config = res
    });
  }

  activated() {
    this.getConfig();
    this.searchTable();
  }
}
